import { combineReducers } from 'redux';

import {
  LOAD_USER_PROPERTIES,
  SET_USER_PROPERTY,
  RESET_USER_PROPERTIES,
} from '../../actions/userProperties/constants';
import createReducer from '../../utils/createReducer';

const loaded = createReducer(false, {
  [LOAD_USER_PROPERTIES]: () => true,
  [RESET_USER_PROPERTIES]: () => false,
});

const props = createReducer(
  {},
  {
    [SET_USER_PROPERTY]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft[payload.key] = payload.value;
    },
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [LOAD_USER_PROPERTIES]: (draft, { payload }) => payload.userProperties,
    [RESET_USER_PROPERTIES]: () => ({}),
  }
);

export default combineReducers({
  loaded,
  props,
});
